export default class CollectiviteDto {
    constructor(object) {
        this.id = object.id
        this.code = object.code
        this.name = object.name
        this.labelWithCode = `${object.name} [${object.code}]`
        this.sectorCode = object.sectorCode
        this.collectiviteType = object.collectiviteType
        this.siren = object.siren
        this.inseeNumber = object.inseeNumber
        this.isSingleManagementUnit = object.isSingleManagementUnit ?? false
        this.creationDate = object.creationDate
        this.sispeaCode = object.sispeaCode
        this.hasAEP_skill = object.hasAEP_skill ?? false
        this.AEP_code = object.AEP_code
        this.hasSanitationSkill = object.hasSanitationSkill ?? false
        this.sanitationCode = object.sanitationCode
        this.contactFunction = object.contactFunction
        this.address = object.address
        this.addressComplement = object.addressComplement
        this.postalCode = object.postalCode
        this.city = object.city
        this.email = object.email
        this.contactTitle = object.contactTitle
        this.contactPhone = object.contactPhone
        this.openHours = object.openHours
        this.acronym = object.acronym
        this.headquarters = object.headquarters
        this.headers = ['id', 'code', 'name', 'siren', 'inseeNumber', 'city', 'email', 'contactPhone']
    }
}